import React from 'react';
import type { Icon } from './types';

export const Share: Icon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        className={className}
    >
        <path
            d="M8.99897 0.833313L14.8319 6.66627L13.6534 7.84478L9.83268 4.02405L9.83268 14.1666H8.16602L8.16602 4.02329L4.34453 7.84478L3.16602 6.66627L8.99897 0.833313Z"
            fill="#3659E3"
        />
        <path
            d="M0.666016 15.8333V9.99998H2.33268V15.8333C2.33268 16.2935 2.70578 16.6666 3.16602 16.6666H14.8327C15.2929 16.6666 15.666 16.2935 15.666 15.8333V9.99998H17.3327V15.8333C17.3327 17.214 16.2134 18.3333 14.8327 18.3333H3.16602C1.7853 18.3333 0.666016 17.214 0.666016 15.8333Z"
            fill="#3659E3"
        />
    </svg>
);
